export default {
    _prefix: "qualityFormEditor.answerProperties",
    labels: {
        title: "Answer Properties",
        addNA: "Add N/A as an Answer",
        requireComments: "Require Additional Comments",
        nps: {
            title: "NPS Answer Properties",
            requestFollowUp: "Include Follow-Up Question",
            optionalCheck: "Set Follow-Up Question as Optional",
            maximumResponseCharacters: "Maximum characters in response",
        },
        freeText: {
            optionalCheck: "Question Response is Optional",
        },
    },
    errors: {
        maxResponseCharsInvalid: (maxResponseCharacters: {
            maxResponseCharacters: number;
        }) =>
            "Maximum characters must be an integer between 1 and {{maxResponseCharacters}}.",
        naEnabledRequiredForQuestion:
            '"Add N/A as an Answer" must be checked for this question',
    },
};
